import { DashboardResponse } from "@practium/features/api";
import { FileCheckIcon, PlantIcon, UsersIcon } from "@practium/ui";
import { companyAnalysisChartConfig, companyConsultantActivityConfig, companyPropertiesConfig, companyRecommendationsChartConfig, companyTeamDonutConfig } from "./companyCharts.config";
import { DashboardConfig } from "@practium/features/dashboard";
import { getCompanyChartsData } from "./mappers";


export const getCompanyDashboardConfig = (navigate: (path: string) => void, data?: DashboardResponse): DashboardConfig => {
    const {
        monthlyChartData,
        teamData,
        recommendationsData,
        propertiesData,
        lineChartData,
    } = getCompanyChartsData(data);

    return {
        stats: [
            {
                id: 'propriedades',
                label: data?.cards[0].title || 'Propriedades Gerenciadas',
                value: data?.cards[0].value || null,
                trendValue: data?.cards[0].variationPercent || null,
                trendLabel: 'vs mês anterior',
                trendDirection: (data?.cards?.[0]?.variationPercent ?? 0) > 0 ? 'up' : 'down',
                icon: <PlantIcon style={{ fontSize: '1.5rem', color: 'var(--icon-default)' }} />,
            },
            {
                id: 'consultores',
                label: data?.cards[1].title || 'Consultores Ativos',
                value: data?.cards[1].value || null,
                trendValue: data?.cards[1].variationPercent || null,
                trendLabel: 'este mês',
                trendDirection: (data?.cards?.[1]?.variationPercent ?? 0) > 0 ? 'up' : 'down',
                icon: <UsersIcon style={{ fontSize: '1.5rem', color: 'var(--icon-default)' }} />,
            },
            {
                id: 'recomendacoes',
                label: data?.cards[2].title || 'Recomendações Geradas',
                value: data?.cards[2].value || null,
                trendValue: data?.cards[2].variationPercent || null,
                trendLabel: 'vs mês anterior',
                trendDirection: (data?.cards?.[2]?.variationPercent ?? 0) > 0 ? 'up' : 'down',
                icon: <FileCheckIcon style={{ fontSize: '1.5rem', color: 'var(--icon-default)' }} />,
            },
        ],
        promotion: {
            title: 'Expanda sua equipe',
            subtitle: 'Vincule novos profissionais e\naumente sua capacidade de atendimento',
            buttonText: 'Gerenciar Equipe',
            onButtonClick: () => { navigate('/usuarios') },
        },
        slots: [
            {
                type: 'comparisonBar',
                size: 'twoThirds',
                config: {
                    ...{
                        ...companyAnalysisChartConfig,
                        mainValue: data?.monthlyChart?.title,
                        footerText: data?.monthlyChart?.subtitle,
                        trendValue: `${data?.monthlyChart?.growthPercentage}%`,
                        trendDirection: (data?.monthlyChart?.growthPercentage ?? 0) > 0 ? 'up' : 'down',
                    },
                    mainValue: data?.monthlyChart?.title,
                    footerText: data?.monthlyChart?.subtitle,
                    trendValue: `${data?.monthlyChart?.growthPercentage}%`,
                    trendDirection: (data?.monthlyChart?.growthPercentage ?? 0) > 0 ? 'up' : 'down',
                },
                data: monthlyChartData,
            },
            {
                type: 'donut',
                size: 'oneThird',
                config: companyTeamDonutConfig,
                data: teamData,
            },
            {
                type: 'pie',
                size: 'oneThird',
                config: companyRecommendationsChartConfig,
                data: recommendationsData,
            },
            {
                type: 'metricList',
                size: 'oneThird',
                config: companyPropertiesConfig,
                data: propertiesData,
            },
            {
                type: 'comparisonLine',
                size: 'oneThird',
                config: {
                    ...companyConsultantActivityConfig,
                    mainValue: data?.lineCharts[0]?.subtitle,
                    trendValue: `${data?.lineCharts[0]?.growthPercentage}%`,
                    footerText: data?.lineCharts[0]?.period
                },
                data: lineChartData,
            },

        ]
    }
}
